export enum BankPermissions {
  VIEW_BANK = "view_bank",
  CREATE_BANK = "create_bank",
  UPDATE_BANK = "update_bank",
  DELETE_BANK = "delete_bank",
  ARCHIVE_BANK = "archive_bank",
}

export const BankPermissionsText: Record<BankPermissions, string> = {
  [BankPermissions.VIEW_BANK]: "View Bank",
  [BankPermissions.CREATE_BANK]: "Create Bank",
  [BankPermissions.UPDATE_BANK]: "Update Bank",
  [BankPermissions.DELETE_BANK]: "Delete Bank",
  [BankPermissions.ARCHIVE_BANK]: "Archive Bank",
};
